import React, { useEffect, useState } from "react";
import { Dropdown, Form } from "semantic-ui-react";

const retentionMarks = [
  {
    key: "open",
    value: "open",
    text: "Open",
    label: { color: "red", empty: true, circular: true },
  },
  {
    key: "pending",
    value: "pending",
    text: "Pending",
    label: { color: "blue", empty: true, circular: true },
  },
  {
    key: "closed",
    value: "closed",
    text: "Closed",
    label: { color: "grey", empty: true, circular: true },
  },
];

const TicketStatusSelect = ({ name, value, style, onChange }: any) => {
  const [currentValue, setCurrentValue] = useState<any>(value);

  useEffect(() => {
    setCurrentValue(value);
  }, [value]);

  return (
    <Form.Field>
      <Dropdown
        name={name}
        value={currentValue}
        fluid
        multiple
        search
        selection
        options={retentionMarks}
        placeholder='Select Status'
        style={style}
        onChange={(event, { value }) => {
          onChange(value);
        }}
      />
    </Form.Field>
  );
};

export default TicketStatusSelect;
